module.exports = __webpack_public_path__ + "img/73800.4d45851c.jpg";